import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pageTitleSpec, withEnvTag } from '@/lib/pageTitle';
import { DEV_WORKTREE } from '@/config/build';

/** Keeps document.title in sync with the route, so browser tabs stop all
 * reading "Flat Hero". Admin console gets literal Polish "· Ops" titles
 * (untranslated by design); public routes render "<t(key)> · Flat Hero" and
 * follow language switches. Mapping lives in src/lib/pageTitle.ts. */
export function DocumentTitle() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const spec = pageTitleSpec(pathname);
    const base = !spec
      ? 'Flathero.pl'
      : 'literal' in spec
        ? spec.literal
        : `Flathero.pl: ${t(spec.key)}`;
    document.title = withEnvTag(base, window.location.hostname, DEV_WORKTREE);
  }, [pathname, t, i18n.language]);

  return null;
}
